import { render, staticRenderFns } from "./VehicleEventProblemSbarChart.vue?vue&type=template&id=165a6072&"
import script from "./VehicleEventProblemSbarChart.vue?vue&type=script&lang=js&"
export * from "./VehicleEventProblemSbarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports